import { compose } from "redux";
import { connect } from "react-redux";
import { Grid } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import React, { useEffect, useMemo } from "react";

import {
  ACTIONS,
  GROUP_FORM,
  SORT_DIRECTION,
} from "features/planner/planner.constants";

import {
  initializeEditGroup,
  editPlanningGroupOnSubmit,
  deleteGroup,
  createPlanningGroupOnSubmit,
  getGroups,
} from "features/planner/planner.actions";

import {
  getSummarizedDataStatesFromState,
  getCurrentUserAppRolesFromState,
} from "app/app.selectors";

import CrudBasePage from "app/components/CrudBasePage";
import { getAccessControlButton } from "utils/component.util";
import { hasRequiredAccessLevel, getModifiedByValue } from "utils/app.util";
import { getPlanningGroupsFromState } from "features/planner/planner.selectors";
import PlanningGroupForm from "features/planner/settings/planningGroups/components/PlanningGroupForm";

const SettingsPlanningGroupsContainer = ({
  Icon,
  groups,
  dataState,
  breadcrumb,
  dispatchOnLoad,
  crudAccessLevel,
  currentUserAppRoles,
  dispatchDeleteGroup,
  dispatchEditGroupOnSubmit,
  dispatchInitializeEditGroup,
  dispatchCreatePlanningGroupOnSubmit,
}) => {
  useEffect(() => {
    dispatchOnLoad();
  }, [dispatchOnLoad]);

  const columns = useMemo(
    () => [
      {
        xs: true,
        title: "Name",
        getSortProperty: group => group.get("name"),
      },
      {
        xs: true,
        component: Grid,
        title: "Modified by",
        getSortProperty: item => item.get("modifiedBy"),
        getValue: getModifiedByValue,
      },
    ],
    [],
  );

  const actions = useMemo(
    () => [
      getAccessControlButton(
        crudAccessLevel.delete,
        dispatchDeleteGroup,
        <Delete fontSize="small" />,
        "Delete",
      ),
    ],
    [crudAccessLevel, dispatchDeleteGroup],
  );

  return (
    <CrudBasePage
      Icon={Icon}
      title={breadcrumb}
      items={groups}
      displayAddButton={hasRequiredAccessLevel(
        crudAccessLevel.create,
        currentUserAppRoles,
      )}
      displaySearchField
      dataState={dataState}
      EditEntityFormComponent={PlanningGroupForm}
      CreateEntityFormComponent={PlanningGroupForm}
      SortableListProps={{
        defaultSortColumn: 0,
        actions: actions,
        columns: columns,
        defaultSortDirection: SORT_DIRECTION.ASC,
        getKey: planningGroup => planningGroup.get("id"),
        onRowClick: hasRequiredAccessLevel(
          crudAccessLevel.edit,
          currentUserAppRoles,
        )
          ? dispatchInitializeEditGroup
          : null,
      }}
      EditModalProps={{
        submitText: "Save",
        title: "Edit Planning Group",
        formTitleField: GROUP_FORM.NAME,
        onSubmit: dispatchEditGroupOnSubmit,
      }}
      CreateModalProps={{
        submitText: "Create",
        title: "Create Planning Group",
        onSubmit: dispatchCreatePlanningGroupOnSubmit,
      }}
      editEntityForm={{
        form: GROUP_FORM.ID,
      }}
      createEntityForm={{
        form: GROUP_FORM.ID,
      }}
    />
  );
};

export default compose(
  connect(
    state => ({
      groups: getPlanningGroupsFromState(state),
      currentUserAppRoles: getCurrentUserAppRolesFromState(state),
      dataState: getSummarizedDataStatesFromState(
        state,
        ACTIONS.GET_GROUPS,
        ACTIONS.DELETE_GROUP,
      ),
    }),
    {
      dispatchOnLoad: getGroups,
      dispatchDeleteGroup: deleteGroup,
      dispatchInitializeEditGroup: initializeEditGroup,
      dispatchEditGroupOnSubmit: editPlanningGroupOnSubmit,
      dispatchCreatePlanningGroupOnSubmit: createPlanningGroupOnSubmit,
    },
  ),
)(SettingsPlanningGroupsContainer);
